import { SAASBRANDNAME } from '../assets/data/enum/saasBrandName.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'mccormick',
    textName: 'McCormick Farm',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=mccormick',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=mccormick',
    enableForgotPassword: false,
    enableRegistration: false,
    enableLoginForm: false,
    activeSocial: [SAASBRANDNAME.MCCORMICK],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    welcomeUserCheck: false,
    store: false,
    legalModeBySaas: true,
    storewebAppUrl: 'https://store-argo.xfarm.ag/mccormick/index.html',
  },
  apiBaseUrl: 'https://api-mccormick-farm.xfarm.ag/',
  SSOfrontAppCallback: 'https://app-mccormick-farm.xfarm.ag/#/oauthCheck?token=',
  launchDarklyKey: '676048f73a1456098504a733',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/mccormick/',
  palette: {
    '--p-xfarm-50': '#ffdbd6',
    '--p-xfarm-100': '#ffb6ae',
    '--p-xfarm-200': '#ff9087',
    '--p-xfarm-300': '#fa6763',
    '--p-xfarm-400': '#ef3340',
    '--p-xfarm-500': '#d5313a',
    '--p-xfarm-600': '#bb2e34',
    '--p-xfarm-700': '#a22b2e',
    '--p-xfarm-800': '#8a2728',
    '--p-xfarm-900': '#722323',
    '--p-xfarm-950': '#5c1f1d',
  },
  primary: '#ef3340',
  primaryOpacity: '#e8515a',
  primaryOpacity15: '#e8515a26',
  secondary: '#212322',
  btnSuccess: '#ef3340',
  navBarColor: '#ef3340',
  backgroundSplashScreen: '#ef3340',
  colorSidebarHeader: '#212322',
  textLoginVersion: '#FFFFFF',
};
